/* Iframe modal — the values that are policy rather than markup, kept together so
 * the security-owned sandbox grant is reviewable in one place. */

/**
 * How long to wait for the frame's `load` before showing the error state.
 *
 * ⚠ The timeout is the BACKSTOP: a page refused by `X-Frame-Options` or a CSP
 * `frame-ancestors` fires no `error` event in any browser, and `onLoad` can fire
 * on the browser's own error page — so a frame that never loads is only
 * distinguishable by the wait. Generous, because a cold CHLUP render on a
 * throttled connection is slow but valid.
 */
export const IFRAME_LOAD_TIMEOUT_MS = 12000;

/**
 * The iframe's `sandbox` grant.
 *
 * ⚠ A SECURITY DECISION, owned by security review (WAT-12240). `allow-scripts`
 * with `allow-same-origin` is effectively no sandbox for a same-origin page, and
 * CHLUP needs both — its scripts run and push to the parent frame's `dataLayer`.
 * A cross-origin page keeps its own origin under this grant, so it cannot reach ours.
 */
export const DEFAULT_SANDBOX =
  "allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox";

/** The frame's feature policy. Fullscreen only, until a frame asks for more. */
export const DEFAULT_ALLOW = "fullscreen";

/* Default copy — neutral, not business-approved wording, the stance legal-modal
   takes too. Override from the CMS once content has agreed what a reader sees. */
export const DEFAULT_LOADING_CONTENT = "Loading…";
export const DEFAULT_ERROR_CONTENT = "We couldn’t load this content right now.";
export const DEFAULT_ERROR_CTA_LABEL = "Open in a new tab";
